import { CKEditor } from './modules/panel/editor-ckeditor';
import { ColorPicker } from './modules/panel/picker-color';
import { DataTables } from './modules/panel/datatables';
import { DateTimePickers } from './modules/panel/picker-date';
import { DefinedDateRangeChooser } from './modules/panel/defined-date-range-chooser';
import { ExtendedFormControls } from './modules/panel/form-controls-extended';
import { FineUploader } from './modules/panel/fine-uploader';
import { FormValidation } from './modules/panel/form-validation';
import { Forms } from './modules/panel/forms';
import { FullCalendarBasic } from './modules/panel/fullcalendar';
import { GlobalCloner } from './modules/panel/global-cloner';
import { ImageCropper } from './modules/panel/cropper';
import { InputMasks } from './modules/panel/input-masks';
import { InputsBasic } from './modules/panel/form-inputs';
import { InputsCheckboxesRadios } from './modules/panel/form-checkboxes-radios';
import { JqueryUiForms } from './modules/panel/jqueryui-forms';
import { JqueryUiSliders } from './modules/panel/jqueryui-sliders';
import { Modals } from './modules/panel/components-modals';
import { Search } from './modules/panel/search';
import { Select2Selects } from './modules/panel/form-select2';
import { SidebarTrigger } from './modules/panel/sidebar-trigger';
import { TagInputs } from './modules/panel/form-tags-input';

export function panelRun() {
    const $showByValue = $('.js-ci-showbyvalue');
    const $setFields = $('.js-ci-set-fields');
    const $togglePassword = $('.toggle-password, .js-toggle-password');
    const $locationAutocomplete = $('.js-location-autocomplete');
    const $cloners = $('.js-icube-cloner');
    const $editorsJson = $('.js-icube-content-editor');
    const $editorsJsonBasic = $('.js-icube-content-editor-basic');
    const $services =  $('[data-ci-services]');
    const $initRwdTables = $('.js-init-rwd-tables');
    const $paymentsContainer = $('.js-payment-methods');

    // Sidebar navigation
    (function() {

        // Define default class names and options
        var navClass = 'js-main-sidebar',
            navItemClass = 'js-nav-item',
            navItemOpenClass = 'is-active',
            navLinkClass = 'js-nav-link',
            navSubmenuClass = 'js-nav-submenu',
            navSlidingSpeed = 250;

        // Configure collapsible functionality
        $('.' + navClass).each(function() {
            $(this).find('.' + navItemClass).has('.' + navSubmenuClass).children('.' + navItemClass + ' > ' + '.' + navLinkClass).not('.disabled').on('click', function (e) {
                e.preventDefault();

                // Simplify stuff
                var $target = $(this),
                    $navSidebarMini = $('.sidebar-xs').not('.sidebar-mobile-main').find('.sidebar-main .' + navClass).children('.' + navItemClass);

                // Collapsible
                if($target.parent('.' + navItemClass).hasClass(navItemOpenClass)) {
                    $target.parent('.' + navItemClass).not($navSidebarMini).removeClass(navItemOpenClass).children('.' + navSubmenuClass).slideUp(navSlidingSpeed);
                }
                else {
                    $target.parent('.' + navItemClass).not($navSidebarMini).addClass(navItemOpenClass).children('.' + navSubmenuClass).slideDown(navSlidingSpeed);
                }

                // Accordion
                if ($target.parents('.' + navClass).data('nav-type') == 'accordion') {
                    $target.parent('.' + navItemClass).not($navSidebarMini).siblings(':has(.' + navSubmenuClass + ')').removeClass(navItemOpenClass).children('.' + navSubmenuClass).slideUp(navSlidingSpeed);
                }
            });
        });

        // Disable click in disabled navigation items
        $(document).on('click', '.' + navClass + ' .disabled', function(e) {
            e.preventDefault();
        });

        // Scrollspy navigation
        $('.nav-scrollspy').find('.' + navItemClass).has('.' + navSubmenuClass).children('.' + navItemClass + ' > ' + '.' + navLinkClass).off('click');
    }());

    $('[data-popup="tooltip"]').tooltip();

    $('[data-popup="popover"]').popover();
    $(document).on('ci_DataTablesDrawCompleted', function() {
        $('.js-popover-dt').popover();
    });

    // Dropdown submenus. Trigger on click
    (function() {

        // All parent levels require .dropdown-toggle class
        $('.dropdown-menu').find('.dropdown-submenu').not('.disabled').find('.dropdown-toggle').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            // Remove "show" class in all siblings
            $(this).parent().siblings().removeClass('show').find('.show').removeClass('show');

            // Toggle submenu
            $(this).parent().toggleClass('show').children('.dropdown-menu').toggleClass('show');

            // Hide all levels when parent dropdown is closed
            $(this).parents('.show').on('hidden.bs.dropdown', function(e) {
                $('.dropdown-submenu .show, .dropdown-submenu.show').removeClass('show');
            });
        });
    }());

    CKEditor.init();
    ColorPicker.init();
    DataTables.init();
    DateTimePickers.init();
    DefinedDateRangeChooser.init();
    ExtendedFormControls.init();
    FineUploader.init();
    FormValidation.init();
    Forms.init();
    FullCalendarBasic.init();
    ImageCropper.init();
    InputMasks.init();
    InputsBasic.init();
    InputsCheckboxesRadios.init();
    JqueryUiForms.init();
    JqueryUiSliders.init();
    Modals.init();
    Search.init();
    Select2Selects.init();
    SidebarTrigger.init();
    TagInputs.init();

    if ($showByValue.length) {
        import(ICUBE_SHOWBYVALUE).then(() => {
            $showByValue.icubeShowByValue();
        });
    }

    if ($setFields.length) {
        import(ICUBE_SET_FIELDS).then(() => {
            $setFields.icubeSetFields();
        });
    }   

    if ($togglePassword.length) {
        $togglePassword.on('click', function() {
            const $self = $(this);
            const $input = $($self.data('toggle'));
    
            $self.toggleClass("icon-eye icon-eye-blocked"); 
            $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password');
        });
    }

    if ($locationAutocomplete.length) {
        import(ICUBE_LOCATION_AUTOCOMPLETE).then(() => {
            const locationsSource = ICUBE_CONFIG.api_domain + 'domestic/dictionaries/locations?lowercase_country=1';

            $locationAutocomplete.icubeLocationAutocomplete({
                source: locationsSource,
                type: 'city',
                afterAutocomplete: function($fieldBox, autocompletedFields) {
                    $.each(autocompletedFields, function() {
                        /* 
                            .select2-hidden-accessible - select z szukajką (plugin) 
                            .js-form-control-uniform - select uniform (plugin) 
                        */
                        if (this.hasClass('select2-hidden-accessible') || this.hasClass('js-form-control-uniform')) {
                            this.change();
                        }

                        this.trigger('icube.forms.checkfield');
                    })
                }
            });
        });
    }

    if ($cloners.length) {
        $cloners.each(function() {
            const $self = $(this);
    
            /* is in ci-forms form, cloner will be initiated in ci-forms afterInit callback */
            if ($self.closest('.js-ci-forms').length) {
                return false;
            }
    
            GlobalCloner.init($self, {
                CKEditor,
                InputsCheckboxesRadios,
                ExtendedFormControls,
                InputsBasic,
                Select2Selects,
                Forms,
                FullCalendarBasic,
                JqueryUiForms,
                JqueryUiSliders,
                ColorPicker,
                DateTimePickers
                // Search, 
                // Locations
            });
        });
    }

    if ($editorsJson.length || $editorsJsonBasic.length) {
        import(PLUGINS_PATH + 'fancyBox3/dist/jquery.fancybox').then(() => {
            import(MODULES_PATH + 'panel/editor-json').then(({ EditorJson }) => {
                if ($editorsJson.length) {
                    EditorJson.default($editorsJson, {DataTables});
                }
    
                if ($editorsJsonBasic.length) {
                    EditorJson.basic($editorsJsonBasic, {DataTables});
                }
            });
        });
    }

    if ($services.length) {
        import(ICUBE_SERVICES).then(() => {
            $services.icubeServices();
        });      
    }

    if ($initRwdTables.length) {
        import(ICUBE_EDITABLE).then(() => {
            $initRwdTables.icubeEditable({
                iframes: null
            });
        });
    }

    if ($paymentsContainer.length) {
        $paymentsContainer.each(function() {
            const $self = $(this);

            $self.icubeLazyHtml({
                src: 'client/payments/payment/availablemethods?payment_method_id=' + $self.data('id'),
                method: 'POST',
                body: {'action': $self.data('action')}
            });
        });
    }
}